import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { basePermissionManagerApi } from './apis/basePermissionManagerApi'
import { appSlice } from './slices/appSlice'

const rootReducer = combineReducers({
  [basePermissionManagerApi.reducerPath]: basePermissionManagerApi.reducer,
  [appSlice.name]: appSlice.reducer
})

const middleware = getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
  .concat([
    basePermissionManagerApi.middleware
  ])

const store = configureStore({
  reducer: rootReducer,
  middleware
})
export default store

export const testStore = () => configureStore({
  reducer: rootReducer,
  middleware
})
